import React from 'react';
import SingleFirmEmailToggle from './SingleFirmEmailToggle';
import RecordRow from 'components/RecordRow';
import Spacing from 'components/Spacing';
import DefaultAdviserRow from './DefaultAdviserRow';

type Props = {
  investorDetail: {
    _id: string;
    requiresHardCopyReports?: boolean;
    disableAllEmails: boolean;
  };
};

const InvestorCommunication: React.FC<Props> = ({ investorDetail }) => {
  return (
    <Spacing>
      <RecordRow label="System emails">
        <SingleFirmEmailToggle
          investorId={investorDetail._id}
          emailsCurrentlyDisabled={investorDetail.disableAllEmails}
        />
      </RecordRow>
      <RecordRow label="Requires hard copy reports">
        {investorDetail?.requiresHardCopyReports ? 'Yes' : 'No'}
      </RecordRow>
      <RecordRow label="Default adviser">
        <DefaultAdviserRow investorDetail={investorDetail} />
      </RecordRow>
    </Spacing>
  );
};

export default InvestorCommunication;
